import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClear = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 14,
	viewBox: "0 0 16 16",
	fill: "none",
	"aria-hidden": "true",
	...props,
	children: [/* @__PURE__ */ _jsx("line", {
		x1: 4,
		y1: 4,
		x2: 12,
		y2: 12,
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	}), /* @__PURE__ */ _jsx("line", {
		x1: 12,
		y1: 4,
		x2: 4,
		y2: 12,
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})]
});
export default SvgClear;
